import { AxiosInstance } from 'axios'
import { IAgentSession, AgentUiMessage } from '../../../views/KnowledgeEngine/types'

export function sessionsApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/knowledge-engine-agent/sessions'
  return {
    getSessions(params?: { limit?: number, offset?: number }) {
      return api.get<{items: IAgentSession[]}>(baseUrl, { params })
    },
    getSessionMessages(sessionId: string) {
      return api.get<AgentUiMessage[]>(`${baseUrl}/${sessionId}/messages`)
    },
    createSession(sessionId: string) {
      return api.post<IAgentSession>(`${baseUrl}/${sessionId}`)
    }
  }
}
